<template>
  <div class="block block-cust">
    <img :src="bg" class="img-responsive img-bg" alt="" />
    <div class="main animated fadeInUp">
      <div>
        <img class="img-icon" :src="p1" alt="" />
      </div>
      <div class="title">全生命周期管理 · 打造<span>合同极致管控</span></div>
      <div class="title2">吉智合同管理系统助力企业数字化转型</div>
      <InputPhone type="top" />
    </div>
  </div>
</template>

<script>
import bg from "@/assets/images/home/bg.png";
import p1 from "@/assets/images/home/p1.png";
import InputPhone from "@/components/InputPhone.vue";
export default {
  components: {
    InputPhone,
  },
  data() {
    return {
      bg,
      p1,
    };
  },
};
</script>

<style scoped>
.block-cust {
  position: relative;
  padding: 0;
}
.main {
  position: absolute;
  top: 15%;
  bottom: 0;
  width: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  margin-top: 10px;
}
.title span {
  color: yellow;
}
.title2 {
  font-size: 24px;
  margin-bottom: 20px;
}

.img-icon {
  width: 250px;
}

/*  */
.mb .title {
  font-size: 18px;
  margin: 0;
}
.mb .title2 {
  font-size: 13px;
}
.mb .img-bg {
  height: 300px;
}
.mb .img-icon {
  width: 100px;
}
</style>